module.exports = __webpack_public_path__ + "img/varied_four.d35b2933.png";